// extracted by mini-css-extract-plugin
export var centerText = "_7n-8";
export var container = "_7n-0";
export var doughnutContainer = "_7n-7";
export var legend = "_7n-a";
export var legendItemColorDisplay = "_7n-b";
export var legendItemLabel = "_7n-d";
export var legendItemValue = "_7n-c";
export var lg = "_7n-5";
export var maxWidth = "_7n-9";
export var md = "_7n-4";
export var responsive = "_7n-6";
export var sm = "_7n-3";
export var xs = "_7n-2";
export var xxs = "_7n-1";